export default {
  videoContainer: {
    height: '100%',
    width: '100%',
    position: 'relative'
  },
  thumbnail: {
    objectFit: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%'
  },
  soundToggler: {
    position: 'absolute',
    top: '0',
    right: '0',
    zIndex: 1,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '16px',
    svg: {
      width: ['16px !important', '16px !important', '24px !important']
    }
  },
  videoStyles: (fullscreen: boolean, fitVideo: boolean) => {
    return {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      objectFit: fitVideo ? 'contain' : 'cover',
      display: 'block',
      ...(fullscreen ? {} : {
        '&::-webkit-media-controls-fullscreen-button': {
          display: 'none !important'
        }
      })
    };
  }
};